module.exports = __webpack_public_path__ + "img/A3-9-plan.a7a7b9ba.png";